import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import ServiceAreas from "../components/ServiceAreas";
import ContactForm from "../components/ContactForm";
import { serviceAreas, company } from "../mock";
import useSEO from "../hooks/useSEO";
import { placeName } from "../seo";

const groups = [
  { label: "Virginia", match: (a) => !a.region.endsWith("MD") },
  { label: "Maryland", match: (a) => a.region.endsWith("MD") },
];

const ServiceAreasPage = () => {
  useSEO({
    title: "Service Areas: Northern VA, DC & Maryland | Fab Build Pro",
    description: "Fab Build Pro serves Fairfax, Arlington, Alexandria, Loudoun & Prince William counties, Washington D.C. and Maryland from our Vienna, VA office.",
    crumbs: [{ name: "Service Areas", path: "/service-areas" }],
  });
  return (
    <>
      <PageHero
        title="Service Areas"
        subtitle="Check your ZIP code and see all the communities we proudly serve across Northern Virginia, Washington D.C. and Maryland."
      />
      <ServiceAreas showAll />
      <section className="bg-brand-cream py-16" data-testid="service-areas-summary">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="font-display font-extrabold text-brand-navy text-2xl md:text-3xl mb-4">
            Where Fab Build Pro Works
          </h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            Fab Build Pro is a roofing and general contractor based at {company.address}. From our Vienna
            office we provide roof repair, roof replacement, storm damage restoration, siding, windows,
            doors, gutters and remodeling across Northern Virginia — Fairfax County, Arlington, Alexandria,
            Loudoun County and Prince William County — plus Washington, D.C. and nearby Maryland communities.
          </p>
          {groups.map((g) => (
            <div key={g.label} className="mb-6">
              <h3 className="font-display font-bold text-brand-navy text-lg mb-2">{g.label}</h3>
              <p className="text-slate-600 leading-relaxed">
                {serviceAreas.filter(g.match).map((a, i, arr) => (
                  <React.Fragment key={a.slug}>
                    <Link to={`/service-areas/${a.slug}`} className="text-brand-orange hover:underline">
                      Roofing in {placeName(a)}
                    </Link>
                    {i < arr.length - 1 ? " · " : ""}
                  </React.Fragment>
                ))}
              </p>
            </div>
          ))}
        </div>
      </section>
      <ContactForm />
    </>
  );
};

export default ServiceAreasPage;
